import { render, staticRenderFns } from "./TariffItem.vue?vue&type=template&id=54169195&scoped=true"
import script from "./TariffItem.vue?vue&type=script&lang=js"
export * from "./TariffItem.vue?vue&type=script&lang=js"
import style0 from "./TariffItem.vue?vue&type=style&index=0&id=54169195&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54169195",
  null
  
)

export default component.exports